import { isNumberOnly } from '@common/utils';

export function checkValidCatalogProductId(
  catalog_product_id: string | null | undefined,
): catalog_product_id is string {
  return (
    Boolean(catalog_product_id) &&
    typeof catalog_product_id === 'string' &&
    isNumberOnly(catalog_product_id) &&
    catalog_product_id !== '0' &&
    catalog_product_id !== ''
  );
}
